import { Checkbox } from '../../Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectionCheckBox = props => {
  const {
    getRowIdentifier,
    getRowIndex,
    rowCount,
    localize,
    getSelectionCheckboxState,
    getSelectAllCheckboxState,
    getSelectionState,
    selectionMode,
    singleSelectionOverrides,
    hideSelectAll,
    columnHeadersVisible,
    areRowsVisible,
    setSelectAllRows,
    setSelectRow,
    dragging,
    isRowDisabled,
    isRowReadOnly,
    readOnly
  } = props.itemData;
  const rowIndex = props.rowIndex;
  const getAriaLabel = () => {
    if (props.ariaLabel) {
      return props.ariaLabel;
    } else if (props.ariaLabelledBy) {
      return undefined;
    } else {
      return localize('rowSelectionAriaLabel.msg', {
        rowIndex: `${props.rowIndex + 1}`
      });
    }
  };
  const selectedRows = props.itemData.preference?.selectedRows;
  const selectAll = () => {
    if (!selectedRows) return props.itemData.preference?.selectAll;
    const selectedRowsValidated = !areRowsVisible ? true : areRowsVisible(selectedRows);
    if (!selectedRowsValidated) return false;
    return props.itemData.preference?.selectAll;
  };
  const rowKey = rowIndex !== -1 ? getRowIdentifier(rowIndex) : undefined;
  const disabledRow = rowKey ? !!isRowDisabled?.(rowKey) : false;
  const readOnlyRow = readOnly || (rowKey ? !!isRowReadOnly?.(rowKey) : false);
  const checkboxState = props.selectAll ? getSelectAllCheckboxState?.() : getSelectionCheckboxState?.(getRowIdentifier(rowIndex)) ?? getSelectionState?.(getRowIdentifier(rowIndex));
  const checkbox = props.selectAll ? /*#__PURE__*/_jsx(Checkbox, {
    checked: checkboxState ?? (props.selected || false),
    testId: "select-all",
    tooltip: checkboxState ?? selectAll() === true ? localize('deselectAll.tooltip.label') : localize('selectAll.tooltip.label'),
    focusable: false,
    readOnly: readOnly
  }) : /*#__PURE__*/_jsx(Checkbox, {
    checked: dragging === true ? false : checkboxState !== undefined ? checkboxState : props.selected || false,
    testId: `row-${props.rowIndex}`,
    focusable: false,
    ariaLabelledBy: props.ariaLabelledBy,
    ariaLabel: getAriaLabel(),
    disabled: disabledRow,
    readOnly: readOnlyRow
  });
  return /*#__PURE__*/_jsx("div", {
    style: props.style,
    onMouseDown: e => {
      e.preventDefault();
    },
    onClick: e => {
      if (disabledRow || readOnlyRow) return;
      props.itemData?.setInteractiveAction?.(true);
      if (props.selectAll === true) {
        let selectAllState = checkboxState ?? selectAll() === true;
        if (props.itemData.readOnlyAndSelectedRows?.size || 0 > 0) {
          if (props.itemData?.preference?.selectAll === true) selectAllState = true;else if (selectAllState === 'mixed') selectAllState = false;
        }
        setSelectAllRows?.({
          selectAll: !selectAllState,
          interactive: true,
          isRowReadOnly: props.itemData.isRowReadOnly
        });
      } else setSelectRow?.({
        index: rowIndex,
        selected: (selectionMode !== 'single' && selectionMode !== 'singleRadio' || singleSelectionOverrides?.allowDeselection !== false) && (selectedRows?.has(getRowIdentifier(props.rowIndex)) || selectAll() === true) ? false : true,
        selectionType: 'checkbox',
        clearPrevious: false,
        rowCount,
        rangeSelection: e.shiftKey,
        rowKey: getRowIdentifier,
        getRowIndex,
        hideSelectAll,
        columnHeadersVisible,
        areRowsVisible,
        isRowDisabled,
        isRowReadOnly
      });
      e.stopPropagation();
    },
    children: checkbox
  });
};
//# sourceMappingURL=SelectionCheckBox.js.map